<page-title [title]="title"></page-title>

<div class="search-container">
  <mat-form-field class="example-full-width" appearance="outline">
    <mat-label>Faça sua busca pelo paciente</mat-label>
    <input
      type="text"
      matInput
      [formControl]="searchControl"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      placeholder="Buscar paciente, cidade ou estado..."
    />

    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <mat-card *ngIf="showAutocompletePanel" class="autocomplete-panel">
    <mat-list>
      <mat-list-item *ngFor="let suggestion of autocompleteSuggestions" (mousedown)="selectSuggestion(suggestion)" class="suggestion-item">
        <mat-icon matListIcon>person</mat-icon>
        <div matLine>{{ suggestion }}</div>
      </mat-list-item>
    </mat-list>
  </mat-card>
</div>

<div *ngIf="searchControl.value && searchControl.value.length >= 3" class="results-count">
  {{ filteredPatients.length }} paciente{{ filteredPatients.length !== 1 ? 's' : '' }} encontrado{{ filteredPatients.length !== 1 ? 's' : '' }}
</div>

<p>Clique em um cartão para ver mais detalhes.</p>

<div class="col-xs-12 col-lg-6" *ngFor="let patient of patientWaitingPaginated">
  <mat-card (click)="openPatientDetailForm(patient)">
    <div class="col-xs-12 col-md-12">
      <div class="desc">{{ patient.name }}</div>
      <div class="desc">
        {{ patient.address.city }} <span *ngIf="patient.address.city && patient.address?.state">/</span> {{ patient.address.state }}
      </div>
    </div>
  </mat-card>
</div>

<div *ngIf="searchControl.value && searchControl.value.length >= 3 && filteredPatients.length === 0" class="no-results">
  <mat-icon>search_off</mat-icon>
  <p>Nenhum paciente encontrado para "{{ searchControl.value }}"</p>
</div>

<page-pagination [pagination]="pagination" (callback)="paginate($event)" *ngIf="showPagination()"></page-pagination>
